<template>
  <div class="specialtab">
    <div class="drawer-card">
      <van-row>
        <van-col span="8">
          <van-button
            @click="leopardClick"
            v-model="leopard"
            :color="a ? '#1C1C36' : ''"
            class="button-style"
            round
            type=""
            >Leopard {{ odds[10] }}</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button
            @click="straightClick"
            v-model="straight"
            :color="b ? '#1C1C36' : ''"
            class="button-style"
            round
            type=""
            >Straight {{ odds[14] }}</van-button
          >
        </van-col>
        <van-col span="8">
          <van-button
            @click="pairClick"
            v-model="pair"
            :color="c ? '#1C1C36' : ''"
            class="button-style"
            round
            type=""
            >Pair {{ odds[15] }}</van-button
          >
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "specialtab",
  props: ["target", "odds", "combination", "clear"],
  data() {
    return {
      leopard: "",
      a: false,
      straight: "",
      b: false,
      pair: "",
      c: false,
      value: [],
      distVal: {
        val: "",
        total: ""
      }
    };
  },
  watch: {
    combination(newValue, oldValue) {
      if(newValue) {
        this.value.forEach((v,i)=>{
          this.distVal.val += v+";";
        })
        this.distVal.total = this.value.length;
        this.$emit('special',this.distVal);
      }
    },
    clear(newValue, oldValue) {
      if(newValue) {
        this.initOrigin()
      }
    }
  },
  methods: {
    leopardClick() {
      this.a = !this.a;
      if (this.a) {
        this.leopard = this.target[10];
        this.value.push(this.leopard);
      } else {
        this.value.map((val, i) => {
          if (val === this.leopard) {
            this.value.splice(i, 1);
          }
        });
        this.leopard = "";
      }
    },
    straightClick() {
      this.b = !this.b;
      if (this.b) {
        this.straight = this.target[14];
        this.value.push(this.straight);
      } else {
        this.value.map((val, i) => {
          if (val === this.straight) {
            this.value.splice(i, 1);
          }
        });
        this.straight = "";
      }
    },
    pairClick() {
      this.c = !this.c;
      if (this.c) {
        this.pair = this.target[15];
        this.value.push(this.pair);
      } else {
        this.value.map((val, i) => {
          if (val === this.pair) {
            this.value.splice(i, 1);
          }
        });
        this.pair = "";
      }
    },
    initOrigin() {
      this.a = false;
      this.b = false;
      this.c = false;
      this.value = [];
      this.distVal = {
        val: "",
        total: 0
      }
    },
  },
};
</script>

<style>
.drawer-card {
  padding: 20px;
}

.button-style {
  border: 1px solid;
}
</style>
